"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_hook_form_1 = require("react-hook-form");
const google_spreadsheet_1 = require("utils/google-spreadsheet");
const react_1 = __importStar(require("react"));
const parseFile_1 = require("utils/parseFile");
const dayjs_1 = __importDefault(require("dayjs"));
const react_bootstrap_1 = require("react-bootstrap");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const displayWrapper_1 = require("./common/displayWrapper");
const GoogleImportComponent = (props) => {
    const { field: nameField } = (0, react_hook_form_1.useController)({
        name: props.schema.nameFieldPath || "",
        control: props.control,
    });
    const { append } = (0, react_hook_form_1.useFieldArray)({
        name: props.schema.fileFieldPath || "",
        control: props.control,
    });
    const useToken = (0, google_spreadsheet_1.useGoogleToken)();
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const [url, setUrl] = (0, react_1.useState)("");
    const [progress, setProgress] = (0, react_1.useState)(null);
    // We need to handle the export task here to dedupe using useEffect's feature.
    // In case a user cancels sign in first, and later sign in again, the export task will be duplicated
    // because a then-handler for the access-token promise will be registered twice.
    // the stale variable in the useEffect hook can handle this case and cancel the first request.
    const [importTask, setImportTask] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!importTask)
            return;
        let stale = false;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, e_1, _b, _c;
            setProgress({
                status: "importing",
                exportedSheets: 0,
                totalSheets: 0,
            });
            const token = yield useToken().catch(() => undefined);
            // here, if the task is stale (duplicated or out of react tree), the stale variable will be true
            // and results in no-op
            if (stale)
                return;
            if (!token) {
                alert("認証失敗");
                return;
            }
            let fileTitle = "";
            try {
                for (var _d = true, _e = __asyncValues((0, google_spreadsheet_1.importFromGoogleSheet)(token, url)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                    _c = _f.value;
                    _d = false;
                    const signal = _c;
                    if (signal.type === "meta") {
                        fileTitle = signal.fileName;
                    }
                    else if (signal.type === "progress") {
                        setProgress({
                            status: "importing",
                            exportedSheets: signal.importedSheets,
                            totalSheets: signal.totalSheets,
                        });
                    }
                    else if (signal.type === "error") {
                        alert(`エラー: ${signal.message}`);
                    }
                    else if (signal.type === "generated") {
                        setProgress({
                            status: "imported",
                            xlsx: signal.xlsx,
                        });
                        const file = (0, parseFile_1.bookToFile)(signal.xlsx, `インポート-${(0, dayjs_1.default)().format("YYYYMMDDHHmmss")}.xlsx`);
                        nameField.onChange(fileTitle !== null && fileTitle !== void 0 ? fileTitle : `インポート-${(0, dayjs_1.default)().format("YYYYMMDDHHmmss")}.xlsx`);
                        append({
                            file: file,
                            fileName: fileTitle !== null && fileTitle !== void 0 ? fileTitle : `インポート-${(0, dayjs_1.default)().format("YYYYMMDDHHmmss")}.xlsx`,
                            source: "googleImport",
                        });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }))();
        return () => {
            stale = true;
        };
    }, [importTask]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { onClick: () => setOpenModal(true), variant: "outline-primary" }, "Google \u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u304B\u3089\u30A4\u30F3\u30DD\u30FC\u30C8"),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: openModal, size: "lg", onHide: () => setOpenModal(false) },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Google \u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u304B\u3089\u30A4\u30F3\u30DD\u30FC\u30C8")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                "\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306EURL:",
                " ",
                (progress === null || progress === void 0 ? void 0 : progress.status) === "imported" && react_1.default.createElement(react_1.default.Fragment, null, "\u51FA\u529B\u5B8C\u4E86 "),
                (progress === null || progress === void 0 ? void 0 : progress.status) === "importing" && (react_1.default.createElement(react_1.default.Fragment, null,
                    "\u30A4\u30F3\u30DD\u30FC\u30C8\u4E2D ",
                    progress.exportedSheets,
                    "/",
                    progress.totalSheets)),
                react_1.default.createElement("br", null),
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(Form_1.default.Control, { onChange: (e) => {
                            setUrl(e.target.value);
                        }, value: url, type: "url" }),
                    react_1.default.createElement(Button_1.default, { disabled: url.trim().length === 0 || (progress === null || progress === void 0 ? void 0 : progress.status) === "importing", onClick: () => {
                            setImportTask({ url });
                        } }, "\u30A4\u30F3\u30DD\u30FC\u30C8"))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(Button_1.default, { variant: "outline-primary", onClick: () => setOpenModal(false) }, "\u30AD\u30E3\u30F3\u30BB\u30EB")))));
};
GoogleImportComponent.display = (0, displayWrapper_1.DisplayComponent)("GoogleImportDisplayComponent", () => {
    return "インポート機能は閲覧画面ではご利用いただけません";
});
exports.default = GoogleImportComponent;
